import React, { useEffect, useState } from "react";
import { auth } from "../assets/Logic/firebase";
import { onAuthStateChanged } from "firebase/auth";
import type  { User } from "firebase/auth";

const ProfilePage: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <h1 className="text-2xl font-bold mb-4">You’re not logged in</h1>
        <p className="text-gray-600">Please log in to view your profile.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center py-20">
      <img
        src={user.photoURL || "/assets/Images/default-avatar.png"}
        alt="Profile"
        className="w-24 h-24 rounded-full mb-4"
      />
      <h1 className="text-2xl font-bold">{user.displayName || "Anonymous"}</h1>
      <p className="text-gray-600">{user.email}</p>
    </div>
  );
};

export default ProfilePage;
